'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alarmDetailsDialog = require('./alarm-details-dialog.controller');

var _alarmDetailsDialog2 = _interopRequireDefault(_alarmDetailsDialog);

var _alarmHeader = require('./alarm-header.directive');

var _alarmHeader2 = _interopRequireDefault(_alarmHeader);

var _alarmRow = require('./alarm-row.directive');

var _alarmRow2 = _interopRequireDefault(_alarmRow);

var _alarmTable = require('./alarm-table.directive');

var _alarmTable2 = _interopRequireDefault(_alarmTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
exports.default = angular.module('thingsboard.alarm', []).controller('AlarmDetailsDialogController', _alarmDetailsDialog2.default).directive('tbAlarmHeader', _alarmHeader2.default).directive('tbAlarmRow', _alarmRow2.default).directive('tbAlarmTable', _alarmTable2.default).name;


// WEBPACK FOOTER //
// ./src/app/alarm/index.js